<template>
  <transition name="player-transition">
    <div
      class="wrapper"
      :class="{
        hide: !renderData.curPlayData || isHiddenPlayerRoute,
        'show-create': isCreatePage,
        'show-player': renderData.curPlayData && !isCreatePage,
      }"
    >
      <div class="wrapper-player-create height-all">
        <GlobalPlayer
          v-show="false"
          ref="refGlobalPlayer"
          :url="renderData.url"
          :loop="renderData.loop"
          @syncProgress="syncProgress"
          @syncPlayState="doSyncPlayState"
          @switch="doSwitch"
          @curPlayEnded="onCurPlayEnded"
          :perContinuousPlaybackTimeCallback="
            onPerContinuousPlaybackTimeCallback
          "
        />
        <transition name="player-transition">
          <div
            class="player"
            :class="{
              'player-show': renderData.curPlayData,
              'player-hide': !renderData.curPlayData,
            }"
            @click="showMusicDetail"
          >
            <i
              :class="!renderData.isPlaying ? 'playing' : 'paused'"
              @click.stop="changeOp"
            />
            <div
              class="recorder"
              :class="renderData.isPlaying ? 'spin' : ''"
            ></div>
            <div class="infoBox width-0">
              <div class="title olh">{{ renderData.curPlayData?.title }}</div>
              <div class="name olh">
                {{ renderData.startTime }} ·
                {{
                  `${
                    getNakeName(renderData.curPlayData, "user.stage_name") ?? ""
                  }`
                }}
              </div>
            </div>
            <div class="closeBtn" @click.stop="closePlayer"><i /></div>
          </div>
        </transition>
        <div
          class="actionBtn"
          v-if="isCreatePage"
          @click="() => toggleCreateEditOpenState(true)"
        >
          <i class="fn-inline"></i>
        </div>
      </div>
      <!-- <div class="wrapper-create height-all" style=“>
        <div class="wrapper-create-btn" @click="() => goCreateDetailPage()">
          <span class="fn-inline"> {{ $$t("common.generation") }}</span>
        </div>
        <div class="wrapper-create-btn" @click="() => goInstrumentalPage()">
          <span class="fn-inline"> {{ $$t("common.bgm") }}</span>
        </div>
        <div
          v-if="ModuleOpenStateControl.editor.opened"
          class="wrapper-create-btn"
          @click="() => goEditorPage()"
        >
          <span class="fn-inline"> {{ $$t("common.audio_edit") }}</span>
        </div>
      </div> -->
    </div>
  </transition>
</template>

<script setup>
import { ref, reactive, watch, watchEffect, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import useGlobalPlayDataStore, {
  curPlayGroupPlayPointMap,
} from "@/store/globalPlayDataStore.js";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import GlobalPlayer from "@/components/media/audioPlayer/MobileGlobalPlayer.vue";
import tools from "@/utils/tools.js";
import feedListApi from "@/api/api/feedListApi.js";

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";

import useUserDataStore from "@/store/userDataStore";

import useCreateRenderType from "@/store/create/createLayoutStore.js";
import useStoreDetailData from "@/store/storeDetail/storeDetailDataStore.js";
import useFeedListStore from "@/store/create/feedListDataStore.js";

const i18n =
  getCurrentInstance()?.appContext.config.globalProperties?.$i18n ?? {};
const { $$t, $$language } = i18n;

const drawer = ref(false);

const refGlobalPlayer = ref(null);

const route = useRoute();
const router = useRouter();
const userDataStore = useUserDataStore();
const globalPlayDataStore = useGlobalPlayDataStore();
const storeDetailDataStore = useStoreDetailData();
const createRenderType = useCreateRenderType();
const feedListDataStore = useFeedListStore();

const {
  toggleCreateEditOpenState,
  toggleEditorOpenState,
  toggleBgmCreateEditOpenState,
} = createRenderType;

const isCreatePage = computed(
  () =>
    route.name == "create" ||
    route.name == "createIndex" ||
    route.name == "editor" ||
    route.name == "instrumental"
);

const isHiddenPlayerRoute = computed(() => route.meta?.hidePlayer);

const stateData = {
  lastReportSong_id: null,
};

const renderData = reactive({
  curPlayData: null,
  url: "",
  duration: 0,
  startTime: "00:00",
  title: "",
  name: "",

  loop: false,
  isPlaying: false,
  tempToggleStatus: false,
  curPlayGroup: null,
  shareSuccessText: "",

  isGenerating: false,
});

const goCreateDetailPage = async () => {
  await router.push({
    name: "create",
  });
  toggleCreateEditOpenState(true);
};

const goEditorPage = async () => {
  await router.push({
    name: "editor",
  });
  toggleEditorOpenState(true);
};

const goInstrumentalPage = async () => {
  await router.push({
    name: "instrumental",
  });
  toggleBgmCreateEditOpenState(true);
};

const syncProgress = (progress, startTime) => {
  renderData.startTime = startTime;
};

const doPlayStateReport = (song_id, play_type) => {
  return new Promise((resolve, reject) => {
    feedListApi
      .doPlayStateReport({
        song_id: song_id,
        play_type: play_type,
      })
      .then((res) => {
        if (res.code == 200) {
          resolve();
        } else {
          reject(res?.msg ?? "save failed");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

const doSyncPlayState = (isPlaying) => {
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  )?.appContext.config.globalProperties;
  const appContext = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  )?.appContext;
  if (isPlaying) {
    globalProperties?.logCustomEvent("single_song_play_click", {
      content_id: (
        renderData.curPlayData?.song_id ?? renderData.curPlayData?.id
      ).toString(),
      duration: Number(renderData.duration).toFixed(2),
      start_position: Number(
        appContext?.config?.globalProperties?.$globalMediaUtils
          ?.globalAudioPlayer?.players[renderData.url]?.currentTime
      )
        .toFixed(2)
        .toString(),
      song_url: renderData.url,
      is_self:
        renderData.curPlayData?.uid == userDataStore?.authData?.user_id ? 1 : 0,
    });
  }

  renderData.isPlaying = isPlaying;
  globalPlayDataStore.setIsPlaying(isPlaying);
  setTimeout(() => {
    if (renderData.isPlaying && renderData.curPlayData) {
      const song_id = renderData.curPlayData?.song_id;
      if (!renderData.curPlayData?.is_played) {
        feedListDataStore
          .doReportPlayedState({}, renderData.curPlayData)
          .then(() => {
            if (song_id == renderData.curPlayData?.song_id) {
              renderData.curPlayData.is_played = true;
            }
          });
      }
    }
  }, 100);
  if (
    renderData.isPlaying &&
    stateData.lastReportSong_id != renderData.curPlayData?.song_id
  ) {
    doPlayStateReport(renderData.curPlayData?.song_id, 1);
    if (curPlayGroupPlayPointMap[renderData.curPlayGroup]) {
      globalProperties?.logClickEvent(
        curPlayGroupPlayPointMap[renderData.curPlayGroup],
        {
          content_id: renderData.curPlayData?.song_id,
        }
      );
    }
  }
  let song_id = renderData.curPlayData?.song_id;
  setTimeout(() => {
    if (
      song_id == renderData.curPlayData?.song_id &&
      !renderData.isPlaying &&
      !isPlaying
    ) {
      updatePipeReadableFlowUrl();
    }
  }, 10 * 60 * 1000);
};

const updatePipeReadableFlowUrl = async (isEnd = false, data) => {
  const appContext = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  )?.appContext;
  if (!globalPlayDataStore.curPlayData) return;
  let isPlaying = isEnd && data?.player?.personalizedConfig?.loop;
  if (
    renderData.curPlayData?.song_id ==
      globalPlayDataStore.curPlayData?.song_id &&
    /\.[0-9A-Za-z]{1,}$/.test(globalPlayDataStore.curPlayData?.mp3_url ?? "")
  ) {
    let url = renderData.url;
    renderData.duration =
      (globalPlayDataStore.curPlayData?.duration_milliseconds ?? 0) / 1000;
    renderData.url = getObjectStorageFullUrl(
      globalPlayDataStore.curPlayData?.mp3_url
    );
    if (renderData.url) {
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(
        renderData.url
      );
      if (
        !isEnd &&
        appContext?.config?.globalProperties?.$globalMediaUtils
          ?.globalAudioPlayer?.players[renderData.url]
      ) {
        appContext.$globalMediaUtils.globalAudioPlayer.players[
          renderData.url
        ].currentTime =
          appContext?.config?.globalProperties?.$globalMediaUtils
            ?.globalAudioPlayer?.players[url]?.currentTime ?? 0;
      }
      if (isPlaying) {
        await appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(
          renderData.url
        );
      }
    }

    setTimeout(() => {
      globalPlayDataStore.updatePipeReadableFlowUrl(renderData.curPlayData);
    }, 10);
  }
};

const onCurPlayEnded = (data) => {
  console.log("onCurPlayEnded", "doPlayStateReport", 1);
  doPlayStateReport(renderData.curPlayData?.song_id, 2);
  updatePipeReadableFlowUrl(true, data);
};

const getNakeName = (item, itemIdField) => {
  const uid = item?.user?.user_id ?? item?.uid
  return (
    tools.getDataByFields(item, itemIdField) ||
    ((uid == userDataStore.userInfo?.user?.user_id  || !uid)?
    (userDataStore.userInfo?.user?.stage_name ?? "") : '')
  )
}

const showMusicDetail = () => {
  if(globalPlayDataStore.curPlayGroup?.startsWith("tts_")){
    return
  }
  drawer.value = true;
  router.push({
    name: "songDetail",
    query: {},
    params: {
      song_id: renderData.curPlayData?.song_id,
    },
    query: {
      ...(route.params?.from || route.query?.from
        ? { from: route.params?.from || route.query?.from }
        : {}),
    },
  });
};

const closePlayer = () => {
  refGlobalPlayer.value.changeOp(false);
  globalPlayDataStore.setCurPlayData(null);
};

const changeOp = (isPlaying) => {
  refGlobalPlayer.value.changeOp(!renderData.isPlaying);
};

const doSwitch = (data) => {
  if (route.meta?.skipNext) {
    return;
  }
  globalPlayDataStore.switchSong(data);
};

const getPlayerKey = (url) => {
  if (!url) return;
  // const index = url.lastIndexOf("?");
  // if (index > -1) {
  //   return getObjectStorageFullUrl(url.substring(0, index));
  // }
  return getObjectStorageFullUrl(url);
};

const onPerContinuousPlaybackTimeCallback = ({
  time,
  url,
  duration,
  startPosition,
}) => {
  const globalProperties = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  )?.appContext.config.globalProperties;
  globalProperties?.logCustomEvent("single_song_play_time", {
    content_id: (renderData.curPlayData?.song_id ?? renderData.curPlayData?.id).toString(),
    stay_time: Number(time).toFixed(2),
    duration: Number(duration).toFixed(2),
    start_position: Number(startPosition).toFixed(2),
    song_url: url,
    is_self:
      renderData.curPlayData?.uid == userDataStore?.authData?.user_id ? 1 : 0,
  });
};

const getAudioUrl = () => {
  const appContext = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  )?.appContext;
  if (
    (globalPlayDataStore.curPlayData?.stream_key &&
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
        ?.currentUrl ==
        getPipeReadableFlowUrl(globalPlayDataStore.curPlayData?.stream_key) &&
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
        ?.players[
        appContext?.config?.globalProperties?.$globalMediaUtils
          ?.globalAudioPlayer?.currentUrl
      ]?.isPlaying) ||
    !globalPlayDataStore.curPlayData?.mp3_url
  ) {
    return getPipeReadableFlowUrl(globalPlayDataStore.curPlayData?.stream_key);
  } else {
    return getObjectStorageFullUrl(globalPlayDataStore.curPlayData?.mp3_url);
  }
};

const initData = () => {
  const appContext = (
    getCurrentInstance() || window?.$getVueCurrentInstance?.()
  )?.appContext;
  const url = renderData.url ?? "";
  const isCurrentUrl =
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
      ?.currentUrl ==
      getPipeReadableFlowUrl(renderData.curPlayData?.stream_key) ||
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
      ?.currentUrl == getObjectStorageFullUrl(renderData.curPlayData?.mp3_url);

  const currentTime = isCurrentUrl
    ? appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
        ?.audio?.currentTime
    : 0;
  renderData.curPlayData = globalPlayDataStore.curPlayData;
  renderData.isGenerating =
    !/\.[0-9A-Za-z]{1,}$/.test(renderData.curPlayData?.mp3_url ?? "") &&
    renderData.curPlayData?.stream_key;
  if (!renderData.curPlayData) return;
  renderData.url = getAudioUrl();
  if (renderData.url != url) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(
      renderData.url,
      {
        duration: renderData.curPlayData?.duration_milliseconds / 1000,
        currentTime: isCurrentUrl ? currentTime : null,
      }
    );
  }
  if (globalPlayDataStore.curPlayData?.duration_milliseconds > 0) {
    renderData.duration =
      (globalPlayDataStore.curPlayData?.duration_milliseconds ?? 0) / 1000;
  }
};

watch(
  () => globalPlayDataStore.curPlayData,
  (newVal) => {
    if (!globalPlayDataStore.curPlayData) {
      renderData.curPlayData = null;
      return;
    }
    initData();
  }
);
watch(
  () => globalPlayDataStore.tempToggleStatus,
  () => {
    renderData.tempToggleStatus = globalPlayDataStore.tempToggleStatus;
    if (renderData.tempToggleStatus) {
      refGlobalPlayer.value.changeTempOp(false);
    } else {
      refGlobalPlayer.value.changeTempOp(true);
    }
  }
);

watch(
  () => globalPlayDataStore.isPlaying,
  (isPlaying) => {
    if (renderData.isPlaying != isPlaying && renderData.url) {
      refGlobalPlayer.value.changeOp(isPlaying);
      renderData.isPlaying = isPlaying;
    }
  }
);

// 如果是隐藏播放器的页面，就暂停播放
watchEffect(() => {
  if (route.meta?.hidePlayer) {
    globalPlayDataStore.isPlaying = false;
  }
});

watch(
  () => globalPlayDataStore.curPlayGroup,
  () => {
    renderData.curPlayGroup = globalPlayDataStore.curPlayGroup;
  }
);

onMounted(() => {
  initData();
});
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  display: none;
  // background: linear-gradient(180deg, rgba(5, 16, 47, 0) 0%, #05102F 52%);
  .wrapper-player-create {
    display: flex;
    justify-content: end;
    // transition: all 0.3s ease-in-out;
    padding: 14px 16px 10px 16px;
    height: 0;
    overflow: hidden;
  }
  .player {
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    border-radius: 30px;
    background: rgba(246, 230, 255, 0.3);
    backdrop-filter: blur(100px);
    .playing {
      left: 20px;
      z-index: 1;
      position: absolute;
      display: block;
      width: 17.5px;
      height: 17.5px;
      background: url("@/assets/img/player/play.svg") no-repeat center;
      background-size: contain;
    }

    .paused {
      left: 20px;
      z-index: 1;
      position: absolute;
      display: block;
      width: 17.5px;
      height: 17.5px;
      background: url("@/assets/img/pause-light-ico.png") no-repeat center;
      background-size: contain;
    }

    .recorder {
      position: relative;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      margin: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url("@/assets/img/player/recorder.png") no-repeat center;
      background-size: contain;
      animation: spinBackground 4s linear infinite;
      animation-play-state: paused;
      position: relative;
      /*&:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: url("@/assets/img/player/recorder.png") no-repeat center;
        background-size: contain;
        animation: spinBackground 4s linear infinite;
        opacity: 0.5;
      }*/
      &.spin {
        animation-play-state: running;
      }
    }

    .infoBox {
      flex: 1;
      color: #fff;

      .title {
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        margin-bottom: 4px;
        width: 100%; /* 标题的宽度是容器的宽度 */
        white-space: nowrap; /* 防止换行 */
        overflow: hidden; /* 隐藏溢出的内容 */
        text-overflow: ellipsis; /* 超过的长度显示省略号 */
      }

      .name {
        font-size: 10px;
        font-weight: normal;
        line-height: 12px;
        opacity: 0.5;
      }
    }

    .closeBtn {
      margin-right: 16px;

      i {
        display: block;
        width: 24px;
        height: 24px;
        background: url("@/assets/img/player/close-m.svg") no-repeat center;
        background-size: contain;
      }
    }
  }

  .actionBtn {
    justify-self: end;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("@/assets/img/create-btn-bg.png");
    background-size: 100% 100%;
    height: 56px;
    border-radius: 56px;
    margin-left: 0;
    width: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    i {
      width: 24px;
      height: 24px;
      background: url("@/assets/img/music-ico-white.png");
      background-size: 100% 100%;
    }
  }
  .wrapper-create {
    width: max-content;
    padding: 14px 16px 10px 16px;
    height: 0;
    overflow: hidden;
    .wrapper-create-btn {
      // background: url("@/assets/img/create-btn-bg.png");
      border-radius: 48px;
      height: 48px;
      width: 33%;
      min-width: max-content;
      margin-right: 8px;
      text-align: center;
      &:first-child {
        background: linear-gradient(106deg, #4fdeff 0%, #e675ff 100%);
      }
      &:nth-child(2) {
        background: linear-gradient(106deg, #f28fff 0%, #5ff4cf 100%);
      }
      &:nth-child(3) {
        background: linear-gradient(106deg, #5ff4cf 0%, #4fdeff 100%);
      }
      &:last-child {
        margin-right: 0;
      }
    }

    i {
      width: 24px;
      height: 24px;
      background: url("@/assets/img/music-ico-white.png");
      background-size: 100% 100%;
      margin-right: 5px;
    }
    span {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 48px;
      padding: 0 30px;

      color: #000000;
      min-width: 114px;
      width: max-content;
    }
  }
  &.hide {
    .wrapper-player-create {
      height: 0;
      padding: 0 16px 0 16px;
      overflow: hidden;
    }
    .wrapper-create {
      height: 0;
      padding: 0 16px 0 16px;
      overflow: hidden;
    }
  }
  &.show-player {
    .wrapper-player-create {
      height: 80px;
      padding: 14px 16px 10px 16px;
    }
    .wrapper-create {
      height: 0;
      padding: 0 16px 0 16px;
      overflow: hidden;
    }

    .actionBtn {
      width: 0;
      margin-left: 0;
      overflow: hidden;
    }
  }
  &.show-create {
    display: block;
    .wrapper-player-create {
      height: 0;
      padding: 0;
    }
    .wrapper-create {
      height: 80px;
      padding: 18px 16px 10px 16px;
      align-items: center;
    }
  }
  &.show-player {
    display: block;
    .wrapper-player-create {
      height: 80px;
      padding: 14px 16px 10px 16px;
    }
    .wrapper-create {
      display: none;
    }
    .actionBtn {
      width: 56px;
      margin-left: 8px;
    }
  }
}

@keyframes spinBackground {
  0% {
    background-position: center;
    transform: rotate(0deg);
  }

  100% {
    background-position: center;
    transform: rotate(360deg);
  }
}
</style>
